import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** 合并 Tailwind 类名，迁移动期布局使用 */
export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};
